<template>
  <section id="founder-section" class="founder-section container flex flex-col items-center mt-24">
    <!-- Title -->
    <h2 class=" responsive-body-large font-semibold leading-6 text-center text-bw-black mb-6 max-md:mt-10">
      {{ t('aboutFounder.title') }}
    </h2>

    <!-- Founder Message -->
    <p class="responsive-title-3 font-semibold text-center text-bw-black mix-blend-multiply max-w-[720px] mb-16 max-md:max-w-full">
      {{ t('aboutFounder.foundermessage') }}
    </p>

    <!-- Founder Content Section -->
    <div class="flex gap-5 max-w-[999px] w-full max-md:flex-col max-md:gap-0">
      <!-- Founder Image & Info -->
      <div class="flex flex-col w-3/10 max-md:w-full items-center md:items-start mb-16 sm:mb-0">
        <img src="@/assets/about/founders/Jordanis_about.png" alt="Jordanis Chatziveroglou" class="w-full max-md:w-3/4 max-md:h-auto rounded-lg" />
        <h3 class="mt-4  responsive-body-large font-semibold leading-6 text-bw-black text-center md:text-left">
          {{ t('aboutFounder.foundername') }}
        </h3>
        <p class="mt-1  responsive-body-small text-bw-darkGrey text-center md:text-left">{{ t('aboutFounder.founder') }}</p>
      </div>

      <!-- Founder Story Text -->
      <div class="text-container mx-auto flex flex-col w-[65%] responsive-body-medium text-neutral-400 space-y-5 max-md:w-full">
        <p>
          {{ t('aboutFounder.paragraph1') }}
        </p>

        <p>
          {{ t('aboutFounder.paragraph2') }}
        </p>

        <p>
          {{ t('aboutFounder.paragraph3') }}
        </p>

        <p>
          {{ t('aboutFounder.paragraph4') }}
        </p>

        <p>
          {{ t('aboutFounder.paragraph5') }}
        </p>

        <p>
          {{ t('aboutFounder.paragraph6') }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
// export default {
//   name: "FounderSection",
// };
</script>
